import React from 'react';
import { Helmet } from 'react-helmet-async';
import { DEFAULT_IMAGE, useClaimHead } from './HeadDefaults';

interface PageSEOProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  keywords?: string;
  image?: string;
  /** Keep the page out of search results (e.g. "Page not found"). */
  noindex?: boolean;
}

/**
 * Complete head set for a simple page (about, FAQ, landing). Claims the head so
 * HeadDefaults steps aside — on React 19 two <Helmet>s mean two <title>s.
 * Use this from class components, which cannot call useClaimHead() directly.
 */
const PageSEO = ({ title, description, canonicalUrl, keywords, image = DEFAULT_IMAGE, noindex = false }: PageSEOProps) => {
  useClaimHead();
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex" />}
      {keywords && <meta name="keywords" content={keywords} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="SecurSpace" />
      <meta property="og:image" content={image} />
    </Helmet>
  );
};

export default PageSEO;
